import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from '../../utils/constants';
import { hasAcceptedContract, isEmployee, isEmployer } from '../../utils/roleUtils';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const shouldCheckContract =
    (isEmployee(user) || isEmployer(user)) && user?.is_email_verified === true;

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  const needsContractGate =
    shouldCheckContract &&
    !hasAcceptedContract(user) &&
    location.pathname !== ROUTES.CONTRACT;

  if (needsContractGate) {
    return <Navigate to={ROUTES.CONTRACT} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
















